/** @jsxImportSource @gasman/smush */

import './sample_graph.css';

import { Component } from '@gasman/smush';

class SampleGraph extends Component {
    constructor(opts) {
        /*
        recognised opts:
        width
        height
        property
        setter
        changeEvent
        className
        startIndex
        vertical
        */
        super();
        this.width = opts.width || 32;
        this.height = opts.height || 16;
        this.property = opts.property;
        this.setter = opts.setter;
        this.changeEvent = opts.changeEvent;
        this.startIndex = opts.startIndex || 0;

        this.sample = null;
        this.undoBuffer = null;
        this.undoPath = null;

        this.table = (
            <table class={'sample-graph ' + (opts.className || '')}></table>
        );
        this.cells = [];
        for (let x = 0; x < this.width; x++) {
            this.cells[x] = [];
        }

        if (opts.vertical) {
            this.table.classList.add('vertical');
            for (let x = 0; x < this.width; x++) {
                let row = <tr></tr>;
                for (let y = 0; y < this.height; y++) {
                    let cell = <td data-x={x} data-y={y}></td>;
                    if (y == 0) cell.className = 'baseline';
                    this.cells[x][y] = cell;
                    row.appendChild(cell);
                }
                this.table.appendChild(row);
            }
        } else {
            this.table.classList.add('horizontal');
            for (let y = 0; y < this.height; y++) {
                let row = <tr></tr>;
                if (y == this.height - 1) row.className = 'baseline';
                for (let x = 0; x < this.width; x++) {
                    let cell = (
                        <td data-x={x} data-y={this.height - 1 - y}></td>
                    );
                    this.cells[x][this.height - 1 - y] = cell;
                    row.appendChild(cell);
                }
                this.table.appendChild(row);
            }
        }

        this.mouseIsDown = false;
        this.activeCommand = null;
        this.table.addEventListener('mousedown', (event) => {
            // only trigger on left mouse button
            if (event.button != 0) return;

            this.mouseIsDown = true;
            this.setValueToCell(event.target);
        });
        this.table.addEventListener('mousemove', (event) => {
            if (this.mouseIsDown) {
                this.setValueToCell(event.target);
            }
        });
    }

    render(container) {
        container.appendChild(this.table);
    }

    bind(sample, opts) {
        opts = opts || {};
        this.unbind();
        this.sample = sample;
        var arr = sample[this.property];
        for (var x = 0; x < this.width; x++) {
            this.renderBar(x, arr[x + this.startIndex]);
        }

        if (opts.undoBuffer) {
            this.undoBuffer = opts.undoBuffer;
            this.undoPath = [...opts.undoPath, this.property];
        }

        this.sample.on(this.changeEvent, this.onChangeValue);
    }

    unbind() {
        if (this.sample) {
            this.sample.removeListener(this.changeEvent, this.onChangeValue);
            this.sample = null;
            this.undoBuffer = null;
            this.undoPath = null;
        }
    }

    show() {
        document.body.addEventListener('mouseup', this.onMouseUp);
    }

    hide() {
        document.body.removeEventListener('mouseup', this.onMouseUp);
    }

    onMouseUp = (event) => {
        // only trigger on left mouse button
        if (event.button != 0) return;

        this.mouseIsDown = false;
        this.activeCommand = null;
    };

    setValueToCell(cell) {
        if ('x' in cell.dataset && 'y' in cell.dataset) {
            if (!this.activeCommand) {
                this.activeCommand = {
                    path: this.undoPath,
                    forward: {},
                    reverse: {},
                };
                if (this.undoBuffer) {
                    this.undoBuffer.push(this.activeCommand);
                }
            }
            let index = parseInt(cell.dataset.x) + this.startIndex;
            let val = parseInt(cell.dataset.y);
            if (!(index in this.activeCommand.reverse)) {
                let oldValue = this.sample[this.property][index];
                this.activeCommand.reverse[index] = oldValue;
            }
            this.sample[this.setter](index, val);
            this.activeCommand.forward[index] = val;
        }
    }

    onChangeValue = (t, val) => {
        this.renderBar(t - this.startIndex, val);
    };

    renderBar(t, val) {
        var column = this.cells[t];
        for (var y = 0; y < this.height; y++) {
            if (val >= y) {
                column[y].classList.add('set');
            } else {
                column[y].classList.remove('set');
            }
        }
    }

    static forField(field, opts) {
        return new SampleGraph({
            width: field.length,
            property: field.name,
            setter: field.setterName,
            changeEvent: field.eventName,
            startIndex: field.startIndex || 0,
            height: field.subfield.max + 1,
            ...opts,
        });
    }
}

export { SampleGraph };
